import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import back from 'asset/img/back.png';
import background from 'asset/img/bk-person.webp';
import white from 'asset/img/white.webp';
import { getCheckinHonors } from 'network';
import Loadding from 'components/Loadding';
import './index.scss';

const Honors = () => {
    const navigate = useNavigate();
    const isMounted = useRef(true);
    const [honors, setHonors] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        isMounted.current = true;
        setLoading(true);
        getCheckinHonors({}).then((res) => {
            if (!isMounted.current) return;
            if (res?.code === 0 && res?.data) setHonors(res.data);
        }).catch(() => {}).finally(() => {
            if (isMounted.current) setLoading(false);
        });
        return () => { isMounted.current = false; };
    }, []);

    const handleBack = () => navigate(-1);

    if (loading && !honors) {
        return (
            <div className="honors-page">
                <img src={background} className="honors-bg" alt="" />
                <img src={white} className="honors-bg honors-bg-white" alt="" />
                <Loadding visible />
                <div className="honors-back-wrap" onClick={handleBack}>
                    <img src={back} alt="返回" />
                </div>
            </div>
        );
    }

    return (
        <div className="honors-page">
            <img src={background} className="honors-bg" alt="" />
            <img src={white} className="honors-bg honors-bg-white" alt="" />
            <div className="honors-back-wrap" onClick={handleBack}>
                <img src={back} alt="返回" />
            </div>
            <div className="honors-header">
                <h1>签到荣誉</h1>
                {honors?.title && (
                    <div className="honors-current-title">{honors.title}</div>
                )}
            </div>
            <div className="honors-badges">
                {(honors?.badges ?? []).map((b) => (
                    <div key={b.id} className={`honors-badge ${b.got ? 'got' : ''}`}>
                        <span className="badge-icon">{b.icon}</span>
                        <div className="badge-info">
                            <div className="badge-name">{b.name}</div>
                            <div className="badge-desc">{b.desc}</div>
                        </div>
                        {b.got && <span className="badge-check">✓</span>}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Honors;
